import gql from 'graphql-tag'

export const CONVERSATIONS = gql`
    query conversations($after: String, $query: String) {
        viewer {
            conversations(
                first: 15
                sort: LAST_MESSAGE_AT_DESC
                after: $after
                query: $query
            ) {
                pageInfo {
                    endCursor
                    hasNextPage
                }
                edges {
                    node {
                        id
                        opponent {
                            companyName
                            user {
                                firstName
                                lastName
                            }
                            storyImage {
                                transformedUrl(
                                    width: 50
                                    height: 50
                                    method: CROP
                                )
                            }
                        }
                        unreadCount
                        lastMessageAtRelative
                        messages(first: 1) {
                            edges {
                                node {
                                    id
                                    content
                                    isRead
                                    isCatalogFeedback
                                    isProductFeedback
                                    source
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`

export const SEARCH_CONVERSATIONS = gql`
    query conversations(
        $filters: JSON
        $search: String
        $first: Int!
        $page: Int
    ) {
        viewer {
            conversations(
                filters: $filters
                search: $search
                first: $first
                page: $page
            ) {
                results {
                    id
                    opponent {
                        companyName
                        user {
                            firstName
                            lastName
                        }
                        storyImage {
                            transformedUrl(width: 50, height: 50, method: CROP)
                        }
                    }
                    unreadCount
                    lastMessageAtRelative
                    messages(first: 1) {
                        edges {
                            node {
                                id
                                content
                                isRead
                                isCatalogFeedback
                                isProductFeedback
                                source
                            }
                        }
                    }
                }
                pageInfo {
                    totalCount
                    hasPreviousPage
                    hasNextPage
                }
            }
        }
    }
`

export const CONVERSATION_MESSAGES = gql`
    query conversationMessages($id: ID!, $after: String) {
        viewer {
            conversation(id: $id) {
                id
                opponent {
                    id
                    companyName
                    user {
                        firstName
                        lastName
                    }
                    storyImage {
                        transformedUrl(width: 50, height: 50, method: CROP)
                    }
                }
                unreadCount
                shouldSanitize
                messages(first: 10, after: $after) {
                    pageInfo {
                        endCursor
                        hasNextPage
                    }
                    edges {
                        node {
                            id
                            content
                            isRead
                            isCatalogFeedback
                            isProductFeedback
                            isMassMessage
                            source
                            data {
                                listingId
                                productId
                                productSku
                                productTitle
                            }
                            senderDatabaseId
                            createdAtFormatted
                            files {
                                isImage
                                originalFilename
                                transformedUrl(
                                    width: 64
                                    height: 64
                                    method: CROP
                                )
                                originalUrl
                            }
                        }
                    }
                }
            }
        }
    }
`

export const CONVERSATION_STOREFRONTS = gql`
    query conversationStorefronts($supplierId: ID!) {
        storefronts(supplierId: $supplierId) {
            edges {
                node {
                    id
                    name
                    slug
                    isDropshipping
                }
            }
        }
    }
`

export const CONVERSATION_MESSAGE_CREATE = gql`
    mutation ConversationMessageCreate(
        $content: String!
        $conversationId: ID!
        $files: [ConversationMessageFileInput]
    ) {
        conversationMessageCreate(
            input: {
                content: $content
                conversationId: $conversationId
                files: $files
            }
        ) {
            conversationMessage {
                id
                content
                isRead
                senderDatabaseId
                createdAtFormatted
                files {
                    isImage
                    originalFilename
                    transformedUrl(width: 64, height: 64, method: CROP)
                    originalUrl
                }
            }
            userErrors {
                field
                message
            }
        }
    }
`

export const CONVERSATION_MARK_AS_READ = gql`
    mutation ConversationMarkAsRead($conversationId: ID!) {
        conversationMarkAsRead(input: { conversationId: $conversationId }) {
            conversation {
                id
            }
            account {
                unreadCount
            }
        }
    }
`

export const CONVERSATION_CREATE = gql`
    mutation ConversationCreate($url: String!) {
        conversationCreate(input: { url: $url }) {
            conversation {
                id
            }
        }
    }
`
